export default "__VITE_ASSET__CzrdeVvc__"